import { Loader2 } from "lucide-react";

import { Label } from "../ui/label";
import { cn } from "../../lib/utils";

// Sobre quais atendimentos a ação em massa cai.
//
// Compartilhado por encerrar e transferir: a pergunta é a mesma, e duas
// versões dela divergiriam no primeiro ajuste. A contagem não é enfeite — é o
// que separa "encerrar 3" de "encerrar 300", e a pessoa precisa saber disso
// ANTES de clicar, não no toast depois.
const EscolhaDoAlvo = ({ valor, aoMudar, contagens, carregando }) => {
	const opcoes = [
		{
			id: "open",
			rotulo: "Em atendimento",
			ajuda: "Os que estão na mão de alguém.",
			quantos: contagens?.open,
		},
		{
			id: "pending",
			rotulo: "Aguardando",
			ajuda: "Os que ninguém assumiu ainda.",
			quantos: contagens?.pending,
		},
		{
			id: "ambos",
			rotulo: "Ambos",
			ajuda: "Tudo que ainda não acabou.",
			quantos:
				contagens && (contagens.open || 0) + (contagens.pending || 0),
		},
	];

	return (
		<div className="space-y-1.5">
			<Label>Quais atendimentos?</Label>
			<div className="grid gap-2 sm:grid-cols-3">
				{opcoes.map((o) => {
					const vazio = !carregando && !o.quantos;

					return (
						<button
							key={o.id}
							type="button"
							onClick={() => aoMudar(o.id)}
							className={cn(
								"rounded-lg border p-2.5 text-left transition-colors",
								valor === o.id
									? "border-primary bg-primary/5"
									: "hover:bg-muted",
								// Opção que não alcança nada continua clicável de propósito:
								// esconder deixaria a pessoa achando que o filtro sumiu.
								vazio && "opacity-60",
							)}
						>
							<span className="flex items-baseline justify-between gap-2">
								<span className="text-sm font-medium">{o.rotulo}</span>
								<span className="text-sm font-semibold tabular-nums">
									{carregando ? (
										<Loader2 className="h-3 w-3 animate-spin" />
									) : (
										(o.quantos ?? 0)
									)}
								</span>
							</span>
							<span className="mt-0.5 block text-xs leading-snug text-muted-foreground">
								{o.ajuda}
							</span>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default EscolhaDoAlvo;
